import { render } from "./UserPresenceModal.vue?vue&type=template&id=780cfdec&scoped=true"
import script from "./UserPresenceModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserPresenceModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserPresenceModal.vue?vue&type=style&index=0&id=780cfdec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780cfdec"]])

export default __exports__